import React from 'react';
import { IconProps } from '@/models/IconProps';

const MiniWindowIcon: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = '#1F2126' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={'0 0 ' + width + ' ' + height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C0.447715 3 0 3.44772 0 4V20C0 20.5523 0.447716 21 1 21H23C23.5523 21 24 20.5523 24 20V4C24 3.44772 23.5523 3 23 3H1ZM22 5H2V19H22V5Z"
        fill={strokeColor}
      />
      <rect x="10" y="12" width="11" height="6" rx="0.5" fill="#1F2126" />
    </svg>
  );
};

export default MiniWindowIcon;
